import React from "react";
import Banner from "../../CountryDetail/Banner/Banner";
import classes from "./Banner1.module.scss";
import CustomImage from "../../CustomImage";
import { isFrappeOrJotFormClass } from "../../../utils/helpers";

function Banner1({ bannerData }: any) {
  return (
    <section className={classes["banner-section-wrapper"]}>
      <div className={classes["banner-container"]}>
        <Banner bannerData={bannerData} imageWrapperStyles={{ margin: "0" }} bannerStyles={{ backgroundColor: "#6C48F0", width: "100%", margin: "-80px 0" }}>
          <div className={classes["banner-1-container"]}>
            <div className={classes["content-container"]}>
              <p>{bannerData?.title ?? ""}</p>
            </div>
            <div className={classes["actions-container"]}>
              <div className={classes["kc-letter-container"]}>
                <CustomImage src="/icons/kc_union.svg" height={187} width={325} alt={"kc-overseas-icon"} objectFit="fill" />
              </div>
              <button
                className={`${classes["contact-us-btn"]} ${bannerData?.button1?.btnLink ? "" : isFrappeOrJotFormClass(bannerData?.button1?.formId ?? "")}`}
                onClick={() => {
                  bannerData?.button1?.btnLink && window.open(bannerData?.button1?.btnLink, "_blank");
                }}
              >
                {bannerData?.button1?.btnTitle ?? ""}
              </button>
              <button
                className={`${classes["enquire-now-btn"]} ${bannerData?.button2?.btnLink ? "" : isFrappeOrJotFormClass(bannerData?.button2?.formId ?? "")}`}
                onClick={() => {
                  bannerData?.button2?.btnLink && window.open(bannerData?.button2?.btnLink, "_blank");
                }}
              >
                {bannerData?.button2?.btnTitle ?? ""}
              </button>
            </div>
          </div>
        </Banner>
      </div>
    </section>
  );
}

export default Banner1;
